import { gql } from "@apollo/client";
import { PROMO_DETAIL_FRAGMENT } from "./getPromoDetail";

export const CREATE_PROMO_PROGRAM = gql`
  ${PROMO_DETAIL_FRAGMENT}
  mutation CreatePromoProgram($params: CreatePromoProgramInput!) {
    createPromoProgram(params: $params) {
      ...PromoDetailFields
    }
  }
`;
